import { Component, computed, input, output } from '@angular/core';
import { DatePickerComponent, FilterHeaderComponent } from '@vectronic/ui';

@Component({
  selector: 'table-datatable-filter-single-date',
  templateUrl: './datatable-filter-single-date.component.html',
  styleUrls: ['./datatable-filter-single-date.component.scss'],
  imports: [FilterHeaderComponent, DatePickerComponent],
})
export class DatatableFilterSingleDateComponent {
  title = input.required<string>();
  value = input<string | undefined>();
  options = input<{ min?: string | Date; max?: string | Date } | undefined>();
  expanded = input.required<boolean>();
  min = computed(() => {
    const min = this.options()?.min;
    return min instanceof Date ? min.toISOString() : min;
  });
  max = computed(() => {
    const max = this.options()?.max;
    return max instanceof Date ? max.toISOString() : max;
  });

  valueChange = output<string | undefined>();
  toggled = output<void>();

  onDateChange(newValue: string | undefined) {
    this.valueChange.emit(newValue);
  }
}
